/*
 * Um bloco da coluna direita que chega depois: isolado, suspenso e adiado.
 *
 * As três coisas andam juntas e por isso moram num componente só —
 *
 *   ChromeBoundary     um chunk que não desce derruba SÓ este bloco. Sem o isolamento por
 *                      bloco, a primeira falha levaria a coluna inteira.
 *   Suspense           o `React.lazy` precisa de um acima; `null` é o fallback certo, porque
 *                      o lugar já está guardado pelo placeholder do gate.
 *   DeferUntilVisible  segura o `import()` até o usuário se aproximar.
 */
import React, { Suspense } from 'react';

import ChromeBoundary from './ChromeBoundary';
import DeferUntilVisible from './DeferUntilVisible';

interface IDeferredBlockProps {
    /** Nome do bloco, para o erro chegar identificado no APM. */
    region: string;
    /** Classe do placeholder, para ele ocupar o mesmo espaçamento do bloco real. */
    className: string;
    /** Altura aproximada do bloco: sem ela a página salta quando ele solta. */
    placeholderHeight: number;
    children: React.ReactElement;
}

const DeferredBlock: React.FC<IDeferredBlockProps> = ({
    region,
    className,
    placeholderHeight,
    children
}) => (
    <ChromeBoundary region={region}>
        <DeferUntilVisible className={className} placeholderHeight={placeholderHeight}>
            <Suspense fallback={null}>{children}</Suspense>
        </DeferUntilVisible>
    </ChromeBoundary>
);

export default DeferredBlock;
